import React from 'react';
import { Box, Paper } from '@mui/material';
import BreadcrumbsWithMenu from '../../BreadcrumbsWithMenu/BreadcrumbsWithMenu';
import FormPageTitle, { FormPageTitleVariant } from './FormPageTitle';
import {
  getShowPageContentInnerSx,
  showPageEntityHeaderWrapperSx,
  showPageHeaderWrapperSx,
  showPagePaperSx,
} from '../../pageLayoutSx';

interface FormPageLayoutWithMenuProps {
  menu: React.ReactElement;
  title?: string;
  titleVariant?: FormPageTitleVariant;
  entityHeader?: React.ReactElement;
  breadcrumbs?: React.ReactElement;
  buttons: React.ReactElement;
  titleActions?: React.ReactNode;
  children: React.ReactElement | React.ReactElement[];
}

const FormPageLayoutWithMenu = ({
  children,
  title,
  titleVariant,
  breadcrumbs,
  entityHeader,
  buttons,
  menu,
  titleActions,
}: FormPageLayoutWithMenuProps) => {
  return (
    <>
      <Paper sx={showPagePaperSx}>
        <BreadcrumbsWithMenu breadcrumbs={breadcrumbs} menu={menu} />
        <Box sx={showPageHeaderWrapperSx}>
          <Box
            sx={{
              ...showPageEntityHeaderWrapperSx,
              marginBottom: entityHeader ? '36px' : 0,
            }}
          >
            {entityHeader}
          </Box>
        </Box>

        <Box sx={{ display: { xs: 'block', md: 'flex' } }}>
          <Box
            sx={{
              mb: '25px',
              ml: { xs: -2, md: '-19px' },
              mr: { xs: -2, md: '35px' },
              flexShrink: 0,
              width: { md: '215px' },
              display: { xs: 'none', md: 'block' },
            }}
          >
            {menu}
          </Box>

          <Box className="show-page__content-inner" sx={getShowPageContentInnerSx(false)}>
            <FormPageTitle
              title={title}
              titleActions={titleActions}
              variant={titleVariant || 'h2'}
              color={titleVariant === 'h4' ? 'primary' : 'brand'}
              containerSx={{ marginBottom: title || titleActions ? 3 : 0 }}
              titleSx={{ marginRight: 2.5 }}
            />

            {children}
            {buttons}
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default FormPageLayoutWithMenu;
